<template>
  <div class="container">
    <legend>Неназначенные заказы на доставку</legend>
    <table class="table table-bordered table-sm">
      <tbody>
      <tr v-for="Reception in Receptions">
        <td class="align-middle">{{ Reception.Reception }}</td>
        <td class="align-middle">{{ Reception.Count }}</td>
        <td width="400">
          <div class="d-flex">
            <v-select v-model="courier" label="Login" :filterable="false"
                      :options="couriers">
              <template slot="no-options">
                начните вводить курьера...
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.Login }} ({{ option.Fname }} {{ option.Lname }})
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.Login }} ({{ option.Fname }} {{ option.Lname }})
                </div>
              </template>
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!courier"
                  v-bind="attributes"
                  v-on="events"
                  v-on:keydown.enter.prevent
                />
              </template>
            </v-select>
          </div>
        </td>
        <td>
          <button class="btn btn-block btn-outline-success m-0" type="button"
                  @click.prevent="saveDelivery">Создать список
          </button>
        </td>
      </tr>
      </tbody>
    </table>

  </div>
</template>
<script>
import { get } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;
// const type = 'partner';

export default {
  components: {
    // DatePicker,
    // PartnerDelivery,
  },
  data() {
    return {
      Receptions: [],
      couriers: [],
      courier: null,
    };
  },
  computed: {
    // customerOrders() {
    //   return _.groupBy(
    //     _.map(this.orders, o => Object.assign({ isExist: this.isExist(o.Id) }, o)),
    //     order => order.CustomerId,
    //   );
    // },
  },
  created() {
    this.fetchReceptions();
    this.fetchCouriers();
  },
  methods: {
    async fetchReceptions() {
      try {
        const data = await get(`${url}/unassigned-delivery-orders`);
        this.Receptions = data.data;
        console.log(this.Receptions);
      } catch (error) {
        if (error.response && error.response.data) {
          this.$toasted.show(error.response.data, { type: 'error' });
        } else {
          this.$toasted.show('Неизвестная ошибка', { type: 'error' });
        }
      }
    },
    async fetchCouriers() {
      const { data } = await get(`${url}/couriers`);
      this.couriers = data;
    },
    async saveDelivery() {
      console.log(1);
    },
    // removeOrder(Id) {
    //   const key = _.findKey(this.orders, o => o.Id === Id);
    //   this.orders.splice(key, 1);
    // },
    // getCustomerHeadBuOrders(orders) {
    //   return _.head(orders).Reception;
    // },
    // async saveDelivery() {
    //   try {
    //     await post(url, {
    //       OrderIDs: this.getOrderIDs(),
    //       CourierId: this.courier.Id,
    //       DeliveryDate: this.deliveryDate,
    //     });
    //     this.existOrders = [];
    //     this.$toasted.show('Доставка сохранена', { type: 'success' });
    //   } catch (error) {
    //     if (error.response && error.response.data) {
    //       if (error.response.status === 409) {
    //         this.existOrders = _.map(error.response.data, 'Id');
    //         this.$toasted.show('Некоторые заказы уже есть в доставке', { type: 'error' });
    //       } else {
    //         this.$toasted.show(error.response.data, { type: 'error' });
    //       }
    //     } else {
    //       this.$toasted.show('Неизвестная ошибка', { type: 'error' });
    //     }
    //   }
    // },
    // getOrderIDs() {
    //   return _.map(this.orders, 'Id');
    // },
    // isExist(Id) {
    //   return this.existOrders.includes(Id);
    // },
    // async fetchCouriers() {
    //   const { data } = await get(`${url}/couriers`);
    //   this.couriers = data;
    // },
  },
};
</script>
